import dayjs from 'dayjs';

export const getAnalysisSubtitle = ({
  userName,
  updatedAt,
}: {
  userName: string;
  updatedAt: number;
}) => {
  return `${userName} - ${dayjs.unix(updatedAt).toNow(true)} ago`;
};
